import DCFTab from '@dcf/js/components/dcf-tab.js';

export default class UNLTab extends DCFTab {
    constructor(tabsGroup, options = {}) {
        super(tabsGroup, options);
    }
}
